import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import productSearchQuery from '~/graphql/productSearch.gql';
import productSearchAlgolia from '~/graphql/productSearchAlgolia.gql';
import { buildCategoryProductsQuery } from '~/helpers/extract-helper';
import { buildCategoryProductsQuery as buildAlgoliaCategoryProductsQuery } from '~/helpers/algolia-extract-helper';
import getCorvusProviderName from '~/helpers/search-data-helpers';

function isCorvusAlgoliaProvider(context) {
  return getCorvusProviderName(context) === 'algolia';
}

function fetchCorvusAlgoliaSearch(_x, _x2, _x3) {
  return _fetchCorvusAlgoliaSearch.apply(this, arguments);
}

function _fetchCorvusAlgoliaSearch() {
  _fetchCorvusAlgoliaSearch = _asyncToGenerator(function* (context, keyword, query) {
    var locale = context.state.i18n.currentLocale.iso;
    var algoliaUserToken = context.$cookies.get('_ALGOLIA') || '';
    var {
      offset,
      limit,
      sortBy,
      orderBy,
      filterBy,
      page,
      algoliaFilters
    } = buildAlgoliaCategoryProductsQuery(query);
    var {
      data: {
        productSearchAlgolia: productSearch
      }
    } = yield context.app.apolloProvider.defaultClient.query({
      query: productSearchAlgolia,
      variables: {
        variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
        locale,
        keyword,
        offset,
        limit,
        sortBy,
        orderBy,
        filterBy,
        page,
        algoliaFilters,
        algoliaUserToken
      }
    });
    var response = {
      productSearch
    };
    return response;
  });
  return _fetchCorvusAlgoliaSearch.apply(this, arguments);
}

function fetchElasticSearch(_x4, _x5, _x6) {
  return _fetchElasticSearch.apply(this, arguments);
}

function _fetchElasticSearch() {
  _fetchElasticSearch = _asyncToGenerator(function* (context, keyword, query) {
    var locale = context.state.i18n.currentLocale.iso;
    var {
      offset,
      limit,
      sortBy,
      orderBy,
      filterBy
    } = buildCategoryProductsQuery(query);
    var response = yield context.app.apolloProvider.defaultClient.query({
      query: productSearchQuery,
      variables: {
        variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
        locale,
        keyword,
        offset,
        limit,
        sortBy,
        orderBy,
        filterBy
      }
    });
    return response.data;
  });
  return _fetchElasticSearch.apply(this, arguments);
}

function fetchSearch(_x7, _x8, _x9) {
  return _fetchSearch.apply(this, arguments);
}

function _fetchSearch() {
  _fetchSearch = _asyncToGenerator(function* (context, keyword, query) {
    if (isCorvusAlgoliaProvider(context)) {
      var _response = fetchCorvusAlgoliaSearch(context, keyword, query);

      return _response;
    }

    var response = fetchElasticSearch(context, keyword, query);
    return response;
  });
  return _fetchSearch.apply(this, arguments);
}

export default fetchSearch;